import React from "react";
import { useSearch } from "~/context/SearchContext";
import type { Condition } from "~/types";

type Props = {
  text: string;
  type: keyof Condition;
  value: string | string[];
};

const SidebarLabel: React.FC<Props> = ({ text, type, value }) => {
  const {
    conditions: selectedConditions,
    addCondition: handleAddCondition,
    removeCondition: handleSubCondition,
  } = useSearch();

  const isValueSelected = (val: string) => {
    return selectedConditions[type].includes(val);
  };

  const isSelected = Array.isArray(value)
    ? value.every(isValueSelected)
    : isValueSelected(value);

  const [selected, setSelected] = React.useState(isSelected);

  const handleToggle = () => {
    const newSelected = !selected;
    setSelected(newSelected);

    if (newSelected) {
      handleAddCondition(type, value);
    } else {
      handleSubCondition(type, value);
    }
  };

  React.useEffect(() => {
    setSelected(isSelected);
  }, [selectedConditions, isSelected]);

  return (
    <div
      onClick={handleToggle}
      onKeyDown={(e) => e.key === "Enter" && handleToggle()}
      role="button"
      tabIndex={0}
      className={`group block rounded ${
        selected ? "selected" : ""
      } hover:bg-primary-light hover:text-primary [&.selected]:text-primary`}
    >
      <div className="flex items-center py-1 px-2 text-xs font-medium leading-[1.4]">
        <p className="w-[calc(100%_-_14px)]">{text}</p>
        <span className="inline-block ml-1 [&_svg]:fill-primary">
          <svg className="hidden w-2.5 h-2.5 group-hover:block group-[.selected]:hidden">
            <use xlinkHref="/symbol-defs.svg#icon-plus"></use>
          </svg>
          <svg className="hidden w-2.5 h-2.5 group-[.selected]:block">
            <use xlinkHref="/symbol-defs.svg#icon-minus"></use>
          </svg>
        </span>
      </div>
    </div>
  );
};

export default SidebarLabel;
